import { ControlType, FetchStatus, Property } from "../../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";
import { LookupProperties, useLookupProperties } from "./LookupProperties";

import { DraftLookupComponent } from "./DraftLookupComponent";
import { IControlAttributes } from "../../../../../base/models";
import { InputLabel } from "../../InputLabel";
import { LookupField } from "./LookupField";
import { Registry } from "../../../../../base/register";
import { SimpleLookup } from "./SimpleLookup";

export const LookupComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useLookupProperties(props);
    const { label, required, title } = properties || {}
    const containerClass = label ? className : ''
    const inputClass = label ? '' : className

    const getLookupNode = useCallback(() => {
        const binding = bindings?.getBinding(Property.InitValue);
        switch (binding?.type) {
            case "Field":
                return <LookupField
                    id={control.controlId}
                    title={title}
                    name={binding.boundValue}
                    {...properties}
                    className={inputClass}
                />
            case "Const":
            case "Expression":
            default:
                return <SimpleLookup
                    id={control.controlId}
                    title={title}
                    {...properties}
                    value={binding?.value}
                    className={inputClass}
                />
        }

        // eslint-disable-next-line
    }, [properties, bindings, control])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <InputLabel
        htmlFor={control.controlId}
        title={title}
        label={label}
        required={required}
        className={containerClass}>
        {getLookupNode()}
    </InputLabel>
}

Registry.addControl({
    id: "bcc2b5d9-a932-4a69-a582-8f8240d7514b",
    name: "Lookup",
    type: ControlType.Lookup,
    properties: LookupProperties,
    component: LookupComponent,
    draftComponent: DraftLookupComponent
})
